module.exports = __webpack_public_path__ + "static/media/icon_config_multimedia.ab8afc59.svg";